import { render, staticRenderFns } from "./ArchivesPanel.vue?vue&type=template&id=cafe8fde&scoped=true&"
import script from "./ArchivesPanel.vue?vue&type=script&lang=js&"
export * from "./ArchivesPanel.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesPanel.vue?vue&type=style&index=0&id=cafe8fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafe8fde",
  null
  
)

export default component.exports